import { animated } from "@react-spring/web";
import styled from "styled-components";

export const StyledRow = styled.div`
  display: grid;
  height: 2.5rem;
`;
export const StyledResultsAnimatedWrap = styled(animated.div)`
  overflow: hidden;
`;
